<template>
  <b-radio
    v-model="localValue"
    :native-value="option.value"
    :name="name"
    :type="option.type"
    size="is-small"
    class="ml-4">
    {{ option.label }}
  </b-radio>
</template>
<script>
export default {
  name: 'PolicyRadioButton',
  props: {
    name: {
      type: String,
      required: true
    },
    option: {
      type: Object,
      required: true
    },
    value: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      localValue: this.value
    };
  },
  watch: {
    localValue(newValue) {
      this.$emit('input', newValue);
    },
    value(newPropValue) {
      this.localValue = newPropValue;
    }
  }
};
</script>
